import { faAngleUp, faAngleDown } from "@fortawesome/free-solid-svg-icons";
import classnames from "classnames";
import Icon from "components/components/Icon/Icon";
import useToggle from "hooks/useToggle";
import {
  ApiData,
  Endpoint,
} from "models/apiDocumentation/apiDocumentationModels";
import React from "react";
import { Link } from "react-router-dom";
import routeConstants from "utils/routeConstants";

import {
  StyledButton,
  StyledCard,
  StyledDiv,
  StyledHeader,
  Title,
  StyledOption,
} from "./style";

interface Props {
  categoryName: string;
  apiData: ApiData;
  selectedEndpoint: Endpoint | null;
}

const ApiCategoryDropdown: React.FC<Props> = ({
  categoryName,
  apiData,
  selectedEndpoint,
}) => {
  const [expanded, toggleExpanded] = useToggle(
    !!selectedEndpoint && selectedEndpoint.tags.includes(categoryName)
  );

  const matchingEndpoints = apiData.endpoints
    .filter((endpoint) => endpoint.tags.includes(categoryName))
    .map((endpoint) => (
      <Link
        to={`${routeConstants.apiDocs}/endpoint${endpoint.url}`}
        key={endpoint.url}
      >
        <StyledOption
          className={classnames({
            "is-active": endpoint.url === selectedEndpoint?.url,
          })}
          data-test-id="dropdown-option"
        >
          {endpoint.summary}
        </StyledOption>
      </Link>
    ));

  return (
    <StyledCard>
      <StyledHeader
        className="card-header"
        onClick={toggleExpanded}
        data-test-id="api-category-dropdown-header"
      >
        <Title
          className="card-header-title"
          data-test-id="api-category-dropdown-title"
        >
          {categoryName}
        </Title>
        <StyledButton
          type="button"
          className="card-header-icon"
          data-test-id="expander-button"
          aria-label={`${categoryName} more options`}
        >
          <Icon iconName={expanded ? faAngleUp : faAngleDown} />
        </StyledButton>
      </StyledHeader>
      <StyledDiv className={classnames({ expanded })}>
        <div className="content" data-test-id="api-category-dropdown-content">
          {matchingEndpoints}
        </div>
      </StyledDiv>
    </StyledCard>
  );
};

export default ApiCategoryDropdown;
